/* eslint-disable new-cap */
<template>
  <div class="classRoomBox">
    <div class="wapTab">
      <wapTab :playTime="playTime" @send="live800"></wapTab>
    </div>
    <div class="home-page">
      <!-- head -->
      <!-- <app-head /> -->
      <!-- main -->
      <el-main class="home-page-main">
        <div class="video-section">
          <div class="main-header video-header">
          </div>
          <!-- 主播放器 -->
          <div class="video-main">
            <!-- <div class="livingavatar" v-if="ckplayerObject.live && showvideo">
              <img :src="avatarInfo.bclass.tavatar" alt="">

            </div> -->
            <div v-show="ckplayerObject.live && showvideo" ref="videoPlayer" id="ckplayerVideo" class="video-sec" />
            <video v-show="!ckplayerObject.live && showvideo" id="ckplayerVideo" :src="ckplayerObject.video"
              autoplay="autoplay" class="video-sec" controls="true" preload ref="videoPlayer" x-webkit-airplay="true"
              webkit-playsinline="true" x5-video-player-type="h5" x5-video-orientation="portraint"
              @ended="onPlayerEnded($event)"
            />

            <!-- 暂时弃用 -->
            <!-- <video-player
              ref="videoPlayer"
              class="video-player vjs-custom-skin"
              :playsinline="true"
              :options="videoPlayerConfig"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @ended="onPlayerEnded($event)"
            /> -->
          </div>
          <!-- craig -- swiper模块 -->
          <!-- <swiper-banner></swiper-banner> -->
          <!-- 房间列表 -->
          <!-- <transition name="fade"> -->

          <!-- </transition> -->
        </div>

        <!-- 公告消息 -->
        <!-- <div class="noticeBox" v-if="showNotice">
          <wapNotice></wapNotice>
        </div> -->
        <div class="chat-container">
          <div class="main-header chat-header">
            <!-- 用户列表按钮 -->
            <!-- <div class="chat-header-left" @click.stop="handleUserList">
              <img
                v-if="!showUserList"
                class="user-list-btn"
                src="./assets/images/chat_user_list.png"
                alt=""
              >
              <img
                v-if="showUserList"
                class="user-list-up-btn"
                src="./assets/images/up-icon.png"
                alt=""
              >
            </div> -->
            <!-- 房间标题 -->
            <div class="chat-header-right">
              <!-- <span>{{ roomInfo.name ? roomInfo.name : "聊天室" }}</span> -->
              <span :class="controlWindow == 1 ? 'currentSpan' : ''" @click="() => { this.controlWindow = 1 }">
                直播交流
              </span>

              <span :class="controlWindow == 2 ? 'currentSpan' : ''"
                @click="() => { this.controlWindow = 2 }">学员晒单</span>
              <span :class="controlWindow == 3 ? 'currentSpan' : ''"
                @click="() => { this.controlWindow = 3 }">讲师介绍</span>
              <!-- <div class="chat-header-line" /> -->
            </div>
            <!-- 房间客服按钮 -->
            <!-- <div class="chat-header-living" @click.stop="handlePrivateChatEvent(1, {}, true)">
              <img src="./assets/images/living-icon.png" alt="客服私聊">
            </div> -->
          </div>
          <!-- 聊天区域 -->
          <div class="chat-main">
            <transition name="fade">
              <div v-if="showUserList" class="user-list">
                <!-- 用户列表组件 -->
                <user-list @closeUser="handleUserList" />
              </div>
            </transition>
            <!-- 聊天区域 -->
            <div class="chat-section">
              <!-- 聊天内容展示区域 -->
              <div v-if="controlWindow == 1" class="chatcont">
                <chat-list @handleEvent="handleEvent" />
              </div>
              <!-- craig -- 课堂讲义模块 -->
              <div v-if="controlWindow == 2">
                <!-- <handouts></handouts> -->
                <printOut></printOut>
              </div>
              <!-- 讲师介绍 -->
              <div v-if="controlWindow == 3" class="introduce">
                <wapTeacher></wapTeacher>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <div v-show="showRoomList" class="room-list" v-click-outside="handleOut">
        <wapRoomlist v-if="loginChecked"></wapRoomlist>
      </div>
      <!-- 礼物记录 - -->
      <div class="gifthistory" v-show="showgiftHistory" v-click-outside="handleHistory">
        <gift-history></gift-history>
      </div>
      <!-- 我的晒单 -->
      <div class="myprint" v-show="showmyPrint " v-click-outside="handlemyprint">
        <myprint></myprint>
      </div>
      <!-- 去晒单 -->
      <div class="gifthistory" v-show="showtoPrint">
        <print-list></print-list>
      </div>
      <el-dialog :visible.sync="dialogObj.dialogVisible" :width="dialogObj.width" :show-close="false"
        :close-on-click-modal="false">

        <!-- 关闭按钮 -->
        <div v-if="dialogObj.isCloseIcon" class="dialog-close" @click.stop="handleCloseDialog" />
        <!-- 登录弹出组件 -->
        <login-item v-if="dialogObj.type === 1" @loginSuccess="handleLoginSuccess" />
        <!-- 禁言弹出组件 -->
        <stop-word v-if="dialogObj.type === 2" />
        <!-- 私聊弹出组件 -->
        <private-talk v-if="dialogObj.type === 3" />
      </el-dialog>
      <el-dialog title="" :visible.sync="craigDialog.registerVisible" :width="craigDialog.registerWidth">
        <div class="registerBox">
          <img class="registerSuccess" src="./assets/images/craig/registerSuccess.png" alt="">
          <div class="registerCenter">
            <div class="registerCenterLeft">
              <p>
                <img src="./assets/images/craig/code.png" alt="">
                <span>扫码下载APP</span>
              </p>
              <button>IOS版</button>
              <button>Android版</button>
            </div>
            <div class="registerCenterRight">
              已下为您的账户密码：
              <p>
                <span>登录账号：{{ registerAfterInfo.username }}</span>
                <span>登录密码：{{ registerAfterInfo.password }}</span>
              </p>
              尊敬的用户为了方便您的交易，红狮为您生成了MT交易账号<br>
              您可以使用MT交易账号交易，也可以直接登录直播间，以上信息将会发送至您的手机<br>
              我们会严格保护您的数据安全
            </div>
          </div>
          <div class="registerButton">
            <p @click="closerDialog">返回直播间</p>
            <p @click="openRegister">充多少送多少</p>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogObj3.dialogVisible" :width="dialogObj3.width" :show-close="false"
        class="loginBox">
        <!-- 关闭按钮 -->
        <div v-if="dialogObj3.isCloseIcon" class="dialog-close" @click.stop="handleCloseDialog3" />
        <!-- 忘记密码弹出组件 -->
        <forget-item v-if="dialogObj3.type === 1" @loginSuccess="handleLoginSuccess" />
      </el-dialog>
      <el-dialog :visible.sync="dialogObj4.dialogVisible" :width="dialogObj4.width" :show-close="false"
        :close-on-click-modal="false">
        <div v-if="dialogObj4.isCloseIcon" class="dialog-close" @click.stop="handleCloseDialog4" />
        <div class="dialog-craigNew">
          <p class="craigNewP">红狮课堂</p>
          <div>
            <h3 v-if="dialogObj4.gq">感谢关注，您的观看时间剩余<span>{{ this.tipTime.minute }}</span>分钟!</h3>
            <h3 v-if="!dialogObj4.gq">感谢关注，游客观看时间已结束!</h3>
            <p>马上注册或者登录账号，观看海量精彩直播</p>
            <button @click="handleLogin(1)">登录</button>
            <button @click="handleLogin(2)">
              <img src="./assets/images/craig/500.png" alt="">
              注册立领$500现金券
            </button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 礼物展示 -->
    <div class="giftDisply" v-if="DisplayShow">
      <img src="./assets/images/wap/displays.png" alt="">
    </div>
    <div class="wapBottom">
      <!-- 送礼物提示 -->
      <div class="send-show" v-if="giftAnimation && roomGiftList.length && roomGiftList[0].nick">
        <img v-if="roomGiftList[0].headerimg" class="avatar" :src="roomGiftList[0].headerimg" alt="">
        <span>{{ roomGiftList[0].nick }}: 为{{ roomGiftList[0].tname }}老师送出 <span class="send-gift">{{
            roomGiftList[0].name }}</span></span>
        <div class="send-cont">
          <img class="send-img" :src="roomGiftList[0].gifticon" alt="">
          <!-- <span class="send-number">X{{ roomGiftList[0].giftnum || 1 }}</span> -->
        </div>
      </div>
      <!-- 功能按钮区域（禁止聊天自动滚动） -->
      <div class="chat-handler">
        <div class="scroll-control">

          <ul v-if="controlShowChat">
            <li :class="controlClass == 1 ? 'liRed' : ''" @click.stop="selectShow(1)">全部</li>
            <li :class="controlClass == 2 ? 'liRed' : ''" @click.stop="selectShow(2)">只看我</li>
            <li :class="controlClass == 3 ? 'liRed' : ''" @click.stop="selectShow(3)">只看讲师</li>
          </ul>
        </div>
        <img class="eyes" v-if="controlWindow == 1" @click.stop="() => { controlShowChat = !controlShowChat }"
          src="./assets/images/wap/eyes.png" alt="">

        <div class="headerBox" v-if="userInfo.id && userInfo.nick.indexOf('游客') == -1">
          <img v-if="controlWindow == 1" @click="() => { control.showDiv = !control.showDiv }" class="showHeaderImg"
            :src="control.headerImg ? control.headerImg : control.imgSrc[0]" alt="">
          <div class="positionBox" v-if="control.showDiv">
            <img @click="() => { control.showDiv = !control.showDiv }" class="closer"
              src="./assets/images/craig/closer.png" alt="">
            <p>
              <img v-for="(item, i) in control.imgSrc" :key="i" :class="control.target == i ? 'borderImg' : ''"
                @click="tag(i, item)" :src="item" alt="">
            </p>
            <span @click="changeImg">更换头像</span>
          </div>
        </div>
        <!-- wap端没有登录时 -->
        <div v-else class="noLogin">
          <img v-if="controlWindow == 1" @click="handleLogin(3)" src="./assets/images/craig/primes.png" alt="">
        </div>
        <div class="send-section" v-if="controlWindow == 1">


          <!-- 输入区域 -->
          <div class="send-input">
            <textarea ref="inputSection" v-model="sendTxt" @keyup.enter="handleSendEvent" :disabled="craig" />
            <p v-if="craig" class="textareaTip"><span @click="handleLogin(3)" style="color:#e90014">登录/注册 </span>
              即可与讲师畅所欲言</p>
          </div>
          <div v-if="isNativeApp" class="native-send-btn" @click="handleSendEvent">发送</div>
          
          <!-- 礼物 -->
          <div class="gift" v-show="ckplayerObject.live">
            <img src="./assets/images/wap/gifts.png" @click.stop="() => { giftsSHow = !giftsSHow }" alt="">
            <div class="giftsContent" v-if="giftsSHow" v-click-outside="handleGift">
              <div class="swiperGift">
                <swiper ref="swiperGift" :options="swiperGiftOption" @mouseenter="pauseSwiper"
                  @mouseleave="resumeSwiper">

                  <div class="swiper-slide" v-for="(item, index) in this.giftPage" :key="index">
                    <div class="gifts-list">
                      <div v-for="(items, indexs) in item" :key="indexs" @click.stop="selectGift(items)"
                        :class="selectindex == items.id ? 'gifts1 gifts' : 'gifts'">
                        <img class="icon" :src="items.icon" alt="">
                        <span :class="selectindex == items.id ? 'gift-inter gift-title' : 'gift-title'">{{ items.name
                          }}</span>
                        <span v-if="!interGrals" :class="selectindex == items.id ? 'gift-name' : 'gift-inter'">{{
                          items.resourcesnum + '积分' }}</span>
                        <span v-if="interGrals"
                          :class="selectindex == items.id ? 'gift-name gift-names' : 'gift-inter'">{{ items.resourcesnum
                          + '积分' }}</span>
                      </div>
                      <div class="gift-dialog" v-show="intergralShow">
                        <img class="closers" @click.stop="showIntergral" src="./assets/images/wap/closer.png" alt="">
                        您的<span>积分</span>不足，请赚取积分再来打赏！
                      </div>
                      <div class="gift-dialog dialog1" v-show="loginShow">
                        <img class="closers" @click="showLogin" src="./assets/images/wap/closer.png" alt="">
                        <span @click="handleLogin(1)">登录</span>后即可送出礼物
                      </div>
                      <div class="gift-dialog dialog2" v-show="submitShow">
                        <img class="closers" @click="showSubmit" src="./assets/images/wap/closer.png" alt="">
                        请<span @click="toSubmit">激活</span>账户，再来打赏哈！
                      </div>
                    </div>
                  </div>
                  <!-- 分页器 -->
                  <div class="swiper-pagination" slot="pagination"></div>

                </swiper>
              </div>
              <!-- <div class="gifts-list">
                <div v-for="(item,index) in giftList" :key="index" @click.stop="selectGift(index)" :class="item.select?'gifts1 gifts':'gifts'"> 
                     <img :src="item.icon" alt="">
                     <span :class="item.select?'gift-inter gift-title':'gift-title'">{{item.name}}</span>
                     <span :class="item.select?'gift-name':'gift-inter'">{{item.resourcesnum+'积分'}}</span>
                </div>
                
              </div> -->

              <div class="intergral">
                <div class="lefts">
                  <span>我的积分：{{ userIntegral.point || 0 }}</span>
                  <span>可兑换奖励：${{ userIntegral.goldpointwjs || 0 }}美元赠金</span>
                </div>
                <div class="sendbox" @click.stop="giveGift">
                  {{ giveGiftTitle }}
                </div>
              </div>
            </div>
          </div>
          <div class="more">
            <img src="./assets/images/wap/more.png" alt="" @click.stop="() => { showList = !showList }">
            <div class="message" v-if="userInfo.utype == 0 && unreadNum > 0"></div>
            <div class="more-list" v-if="showList" v-click-outside="handleMore">
              <div v-if="!isNativeApp" @click="showMini" class="listbox">
                <div class="iconbox">
                  <img class="small" src="./assets/images/gifts/play.png" alt="">

                </div>
                <span>小窗播放</span>
              </div>
              <div @click.stop="toMyprint" class="listbox">
                <div class="iconbox">
                  <img class="print" src="./assets/images/gifts/Vector.png" alt="">
                </div>
                <span>我的晒单</span>
              </div>
              <div @click="shareVideo" class="listbox">
                <div class="iconbox">
                  <img src="./assets/images/gifts/share.png" alt="">
                </div>
                <span>分享好友</span>
              </div>
              <div @click="live800" class="chats">
                <div class="message" v-if="userInfo.utype == 0 && unreadNum > 0">

                </div>
                <div class="iconbox">
                  <img src="./assets/images/gifts/chat.png" alt="">
                </div>
                <span>私聊</span>
              </div>
              <div @click.stop="searchHistory" class="listbox">
                <div class="iconbox">
                  <img src="./assets/images/gifts/gift.png" alt="">
                </div>
                <span>礼物记录</span>
              </div>
              <div @click="toRequest" class="listbox">
                <div class="iconbox">
                  <img class="chatimg" src="./assets/images/gifts/kefu.png" alt="">
                </div>
                <span>在线客服</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 回复引用展示区域 -->
      <div v-if="replyCall.show" class="reply-section">
        <span>{{ replyCall.name }}</span>
        <p>{{ replyCall.txt }}</p>
        <span class="class-reply-btn" @click="handleCloseReplyEvent" />
      </div>
    </div>
    <!-- 分享好友一彈框 -->
    <el-dialog :visible.sync="shareDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs">
      <div class="loginDialogs">
        <!-- 未入金未登录 -->
        <div id="sharetype" v-if="!userInfo.HasFirstDeposit && registerSuccess">
          <img class="teacher" style="width: 100%;" src="./assets/images/teacherJs/wls.png" alt="">

          <div class="sharebottom">

            <Qrcode :link="'https://sem.rlcmarketltd.net/subject/download?channel=N9999'" :size="80" :iconSize="30" />
          </div>
        </div>
        <!-- 未入金登录 -->
        <div id="shareBox" v-if="!userInfo.HasFirstDeposit && !registerSuccess">

          <img v-if="shareWhoami == '马文'" class="teacher" src="./assets/images/teacherJs/mw.png" alt="">
          <img v-if="shareWhoami == '明杰'" class="teacher" src="./assets/images/teacherJs/mj.png" alt="">
          <img v-if="shareWhoami == '万良'" class="teacher" src="./assets/images/teacherJs/wl.png" alt="">
          <img v-if="shareWhoami == '吴龙'" class="teacher" src="./assets/images/teacherJs/wls.png" alt="">
          <img v-if="shareWhoami == '郑宏'" class="teacher" src="./assets/images/teacherJs/zh.png" alt="">
          <img v-if="!['马文','明杰','万良','吴龙','郑宏'].includes(shareWhoami)" class="teacher" src="./assets/images/teacherJs/wls.png" alt="">



          <div class="sharebottom">

            <Qrcode :link="'https://sem.rlcmarketltd.net/subject/download?channel=9999'" :size="80" :iconSize="30" />
          </div>
        </div>
        <!-- 已入金登录 -->
        <div id="sharetypes" v-if="userInfo.HasFirstDeposit&&!registerSuccess">

          <img v-if="shareWhoami == '马文'" class="teacher" src="./assets/images/teacherJs/teacher4.png" alt="">
          <img v-if="shareWhoami == '明杰'" class="teacher" src="./assets/images/teacherJs/teacher5.png" alt="">
          <img v-if="shareWhoami == '万良'" class="teacher" src="./assets/images/teacherJs/teacher6.png" alt="">
          <img v-if="shareWhoami == '吴龙'" class="teacher" src="./assets/images/teacherJs/teacher7.png" alt="">
          <img v-if="!['马文','明杰','万良','吴龙'].includes(shareWhoami)" class="teacher" src="./assets/images/teacherJs/teacher8.png" alt="">
          <div class="sharebottom">

            <Qrcode :link="shareTypesUrl" :size="80" :iconSize="30" />
          </div>

        </div>

        <div class="downloads" @click="downloadsImg">
          <img src="./assets/images/gifts/download.png" alt="">

        </div>
      </div>
    </el-dialog>
    <!-- 原生App内嵌客服页面 -->
    <div v-if="showServicePage" class="native-service-page">
      <div class="native-service-header">
        <img class="native-service-back" src="./assets/images/wap/goback.png" @click="showServicePage = false" alt="返回">
        <span class="native-service-title">客服</span>
      </div>
      <iframe class="native-service-iframe" :src="live800Url" frameborder="0" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
import AppHead from './components/appHead'
import RoomList from './components/roomList'
import UserList from './components/userList'
import ChatList from './components/wap/chatList'
import LoginItem from './components/login'
import StopWord from './components/stopwords'
import PrivateTalk from './components/wap/privatetalk'
import wapTeacher from './components/wap/wapTeacher.vue'
import wapNotice from './components/wap/adverNotice.vue'
import config from './config/index'
import SwiperBanner from './components/swiperBanner.vue'
import Handouts from './components/handouts.vue'
import printOut from './components/wap/printList.vue'
import ForgetItem from './components/forget'
import wapTab from './components/wap/wapTab.vue'
import wapRoomlist from './components/wap/wapRoomlist.vue'
import giftHistory from './components/wap/giftHistory.vue'
import myprint from './components/wap/myPrint.vue'
import printList from './components/wap/printOut.vue'
import { Picker } from "emoji-mart-vue";
import { getAccountInfo as getAccountInfoApi } from "./api/login";
import { getLdxActivityInfo } from "./api/login"
import { queryUserInfo } from '@/apis/user'
import { setSessionStorage, getSessionStorage } from '@/utils/tools'
import { setToken, deleteToken } from "@/utils/cookies";
import { decryptCBC } from "@/utils/IMEI";
import { isReactNative, isAndroidNative, isIOSNative } from "@/utils/tools";


import Qrcode from '@/component/qr-code/index.vue'
import html2canvas from "html2canvas";
import {
  getTeacher,
  getGiftList,
  getPrezzies,
  giveGiftList,
  GetGiveGiftList,
  getUserIntegralData,
} from './api/home'
// 自定义指令，用于处理点击外部区域的事件
const clickOutside = {
  bind(el, binding) {
    // 在元素上绑定一个点击事件监听器
    el.clickOutsideEvent = function (event) {
      // 检查点击事件是否发生在元素的内部
      if (!(el === event.target || el.contains(event.target))) {
        // 如果点击事件发生在元素的外部，则触发指令绑定的方法
        binding.value(event);

      }
    };
    // 在文档上添加点击事件监听器
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    // 在元素上解除点击事件监听器
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};

export default {

  directives: {
    "click-outside": clickOutside, // 注册自定义指令
  },


  name: 'classRoomWap',
  components: {
    AppHead,
    RoomList,
    UserList,
    ChatList,
    LoginItem,
    StopWord,
    PrivateTalk,
    wapTeacher,
    wapNotice,
    SwiperBanner,
    Handouts,
    printOut,
    ForgetItem,
    wapTab,
    wapRoomlist,
    Picker,
    Qrcode,
    giftHistory,
    myprint,
    printList
  },

  data() {
    return {
      loginChecked: false,
      sendTxt: '', // 发送的内容
      sendType: 0, // 发送的消息类型:0、发送普通消息 1、发送回复引用消息 (2、禁言 3、私聊 4、撤回发言) 5、发送@别人的消息
      replyCall: {
        show: false,
        name: '',
        txt: ''
      },
      sendData: {
        broomid: '', // 房间id
        sname: '', // 消息发送人昵称
        sid: '', // 消息发送人id
        rid: '', // 消息接收人id(@别人使用，其他情况为空)
        rname: '', // 消息接收人昵称(@别人使用，其他情况为空)
        type: 0, // 消息类型(11、私聊（必传）)
        param: {
          TXT: '', // 消息内容
          CITE_TXT: '', // 回复引用的内容（回复引用功能下使用）
          CITE_TXT_ID: '', // 回复引用消息id（回复引用功能下使用）
          CITE_TXT_NAME: '' // 回复引用的昵称（回复引用功能下使用）
        }
      },
      craigDialog: {
        registerVisible: false,
        registerWidth: '100%'
      },
      // 控制切换互动窗口和课堂讲义
      controlWindow: 1,
      controlWindow1: false,
      // 控制筛选聊天盒子是否显示
      controlShowChat: false,
      giftsSHow: false,//送礼物
      controlClass: '',
      screenWidth: null,
      // isLogin:false,
      imgSrc: require('./assets/images/craig/headerImg.png'),
      timer: null,
      liveBody: false,
      // 控制头像相关的data
      control: {
        imgSrc: [
          require('./assets/images/craig/avatar/1.png'),
          require('./assets/images/craig/avatar/1.1.png'),
          require('./assets/images/craig/avatar/2.png'),
          require('./assets/images/craig/avatar/2.1.png'),
          require('./assets/images/craig/avatar/3.png'),
          require('./assets/images/craig/avatar/3.1.png'),
          require('./assets/images/craig/avatar/4.png'),
          require('./assets/images/craig/avatar/4.1.png'),
          require('./assets/images/craig/avatar/5.png'),
          require('./assets/images/craig/avatar/5.1.png'),
          require('./assets/images/craig/avatar/6.png'),
          require('./assets/images/craig/avatar/6.1.png'),
          require('./assets/images/craig/avatar/7.png'),
          require('./assets/images/craig/avatar/7.1.png'),
          require('./assets/images/craig/avatar/8.png'),
          require('./assets/images/craig/avatar/8.1.png'),
        ],
        showDiv: false,
        target: '',
        realImg: '',
        headerImg: null,
      },
      // 播放时长
      playTime: '00:00',
      // 礼物列表
      giftList: [
        
      ],
      // 发送礼物
      sendShow: false,
      // 礼物展示
      DisplayShow: false,
      // 更多按钮展示
      showList: false,
      detail: {},
      isMiniVideoPlay: false,
      giftPage: [],//礼物页数
      userIntegral: {}, // 用户积分信息
      selectindex: null,//礼物选择
      giftinfo: null,
      giveGiftTitle: "送出礼物",
      // emptyShow:false,//积分不足
      // loginShow:false,//送礼物未登录
      // submitShow:false,//激活
      // 礼物轮播
      swiperGiftOption: {
        slidesPerView: 1,
        // swiper图片之间的间隔
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        preventClicks: true,
        // 自动播放
        autoplay: {
          delay: 400000, //延迟播放下一张图片
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      showEmoji: false,//是否显示表情包
      // showNotice:true,//公告信息展示
      giftAnimation: false,//送礼物动画

      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
      isX5: navigator.userAgent.indexOf('TBS/') > -1,
      shareDialog: false,//海报分享
      showServicePage: false,//原生App客服内嵌页面
      interGrals: false,//积分不足
      isPiPActive: false,
      transition: [
        { title: '顺势交易不与市场对做', name: '吴龙' },
        { title: '决不要因为失去耐心而退出市场，也决不要因为迫不及待而进入市场', name: '万良' },
        { title: '时间就是金钱，进场时机永远比你的目标价位重要', name: '明杰' },
        { title: '别人贪婪我恐惧，别人恐惧我贪婪', name: '马文' },
      ],
      titleList: [
        {
          title: '老师讲课干货满满',
          title1: '听课之后盈利直线上升！',
          title2: '你也来看看吧~~'
        },
        {

          title: '老师直播课太精彩了',
          title1: '现场互动超活跃',
          title2: '赶快凑热闹吧~~！'
        }, {
          title: '老师讲课干货满满',
          title1: '听课之后盈利直线上升！',
          title2: '你也来看看吧~~'
        }, {
          title: '这么燃的直播间不许你不知道！',
          title1: '老师的课堂真是卧虎藏龙！',
          title2: '评论区堪比神仙打架 赶快来围观~~',

        }, {
          title: '老师的方法太牛了',
          title1: '听他直播课我直接收益爆了',
          title2: '不信你也来听听？'
        },
      ],
      // 随机数据  分享海报标题 箴言
      accountSymbol: {
        title: '耐心等待，时机就是一切', name: '郑宏'
      },
      symbolCount: {},
      getinviteUrl: '',//邀请链接
      shareTypesUrl: '',//专属邀请链接
      inviteCode: '',//邀请码
    
    }
  },
  computed: {
    // 移动端检测
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    // 是否在原生App容器内（ReactNative / Android WebView / iOS WebView）
    isNativeApp() {
      return !!(isReactNative() || isAndroidNative('finish') || isIOSNative())
    },
    // 送礼物列表
    roomGiftList() {
      return this.$store.state.home.roomGiftList;
    },
    showRoomList: {

      get() {
        return this.$store.state.home.showRoomList
      },
      set(v) {
        console.log(v)


      }
      // set方法只写下面这一行也是可以的
      // set(){}


    },
    showvideo(){
      return this.$store.state.home.showvideos
    },
    ckplayerObject() {
      return this.$store.state.home.ckplayerObject
    },
    player() {
      return this.$store.state.home.player
    },
    showUserList() {
      return this.$store.state.home.showUserList
    },
    showNotice() {
      return this.$store.state.home.showNotice
    },
    submitShow() {
      return this.$store.state.home.showSubmit
    },
    loginShow() {
      return this.$store.state.home.showLogin
    },
    intergralShow() {
      return this.$store.state.home.showIntergral
    },
    dialogObj() {
      return this.$store.state.home.dialogObj
    },
    dialogObj3() {
      return this.$store.state.home.dialogObj3
    },
    dialogObj4() {
      return this.$store.state.home.dialogObj4
    },
    userInfo() {
      if (
        !this.$store.state.login.userInfo.id ||
        this.$store.state.login.userInfo.nick.indexOf("游客") !== -1
      ) {
        this.giveGiftTitle = "立即登录";
      } else if (!this.$store.state.login.userInfo.IsBasicAuthentication) {
        this.giveGiftTitle = "激活账户";
      } else if (!this.$store.state.login.userInfo.HasFirstDeposit) {
        this.giveGiftTitle = "激活账户";
      } else {
        this.giveGiftTitle = "送出礼物";
      }
      return this.$store.state.login.userInfo;
    },
    roomList() {
      return this.$store.state.home.roomList
    },
    roomInfo() {
      return this.$store.state.home.roomInfo
    },
    socket() {
      return this.$store.state.home.socket
    },
    privateUserList() {
      return this.$store.state.home.privateUserList
    },
    videoPlayerConfig() {
      return this.$store.state.home.videoPlayerConfig
    },
    roomset() {
      return this.$store.state.home.roomset
    },
    roomtid() {
      return this.$store.state.home.roomtid
    },
    isatuoscroll() {
      return this.$store.state.home.isatuoscroll
    },
    registerSuccess() {
      return this.$store.state.login.registerSuccess
    },
    // craig--newAdd
    teacherInfo() {
      console.log('讲师信息--------++',this.$store.state.home.teacherInfo)
      return this.$store.state.home.teacherInfo
    },
    tipTime() {
      return this.$store.state.home.tipTime
    },
    isguestmessage() {
      return this.$store.state.home.isguestmessage
    },
    userPwd() {
      return this.$store.state.home.userPwd
    },
    isLogin() {
      return this.$store.state.login.isLogin
    },
    chartShowControl() {
      return this.$store.state.login.chartShowControl
    },
    controlTimer() {
      return this.$store.state.home.controlTimer
    },
    distributecustomer() {
      return this.$store.state.home.distributecustomer
    },
    showRed() {
      return this.$store.state.home.showRed
    },
    craig() {
      if (this.userInfo.id && this.userInfo.nick.indexOf('游客') == -1) {
        clearInterval(this.timer)
        if (this.dialogObj4.dialogVisible) {
          this.$store.commit('home/set_dialogobj4', { dialogVisible: false, isCloseIcon: true, width: '98%', });
        }
        return false
      } else {
        if (this.isguestmessage == 0) {
          return true
        } else {
          return false;
        }
      }
    },
    live800Url() {
      return this.$store.state.common.live800UrlUc
    },
    // 未读消息数量
    unreadNum() {
      return this.$store.state.home.customMsgTotal
    },
    // 注册成功
    registerAfterInfo() {
      return this.$store.state.login.registerAfterInfo;
    },
    avatarInfo() {
      return this.$store.state.home.avatarInfo
    },
    // 礼物记录
    showgiftHistory(){
      return this.$store.state.home.showgiftHistory
    },
    // 我的晒单
    showmyPrint(){
      return this.$store.state.home.showmyPrint
    },
    // 去晒单
    showtoPrint(){
      return this.$store.state.home.showtoPrint
    },
    defaultTeacherInfo(){
      return this.$store.state.home.defaultTeacherInfo
    },
    shareWhoami(){
      return (this.teacherInfo && this.teacherInfo[1] && this.teacherInfo[1].whoami) || (this.defaultTeacherInfo && this.defaultTeacherInfo.whoami) || ''
    },

  },
  async created() {
    await this.checkAccessKeyLogin()
    this.loginChecked = true
    this.pageInit();
    // 获取用户信息
    this.getAccountInfo({
      account: this.$store.state.login.userInfo.mtaccr,
    });

    // 获取用户积分
    this.getUserIntegral();
    // craig-- 获取老师和课程信息
    this.getTeacherInfo();
    // setTimeout(()=>{
    //   // craig--获取课堂笔记列表
    //   this.getBnotes();
    // },800)
    // craig--获取登录提示时间间隔
    this.loginSetTime();
    // 传给App.vue,不展示tabbar
    this.$emit('controlShow', true);
    this.getGiftData()

    // 通过token判断是否已登录,通过nick判断是否为游客，通过utype判断是否禁止发言
    if (this.userInfo.utype == 1) {
      this.$store.commit('login/set_isLogin', true);
    } else {
      if (this.userInfo.nick && this.userInfo.nick.indexOf('游客') !== -1) {
        this.$store.commit('login/set_isLogin', false);
      } else if (JSON.parse(sessionStorage.getItem("token")) && JSON.parse(sessionStorage.getItem("token")).token) {
        this.$store.commit('login/set_isLogin', true);
      }
    }
  },
  watch: {
    'registerSuccess'(newVal) {
      console.log('登录成功----',newVal)
      if (newVal) {
        this.craigDialog.registerVisible = true;
      }
    },
    'tipTime'(newVal) {
      if (newVal) {
        // craig--隔固定时间打开提示弹框
        if (!this.isLogin) {
          this.craigSetTime();
        };
      }
    },
    'controlTimer'(newVal) {
      if (newVal) {
        clearInterval(this.timer)
      }
    },
    // 监听路由变化
    $route(to) {
      console.log(to);
    },
    screenWidth: function (n) {
      if (n > 500) {
        this.$router.push({
          name: 'classRoom',
          query: this.$route.query || {}
        })
      }
    },
    roomGiftList(newVal) {
      if (newVal.length >= 1) {
        // 获取直播间送礼物信息
        this.$nextTick(() => {
          if (!this.giftAnimation) {
            // 动画已经停止了 点了新的礼物 执行新的定时器
            this.giftAnimation = true;
            let giftAnimation = setInterval(() => {
              if (this.roomGiftList.length === 1) {
                // 最后一个数组 也是要停止定时器
                this.roomGiftList.shift();
                clearInterval(giftAnimation);
                this.giftAnimation = false;
              } else if (this.roomGiftList.length) {
                // 有长度的话 就必须要删除数组
                this.roomGiftList.shift();
              } else {
                //  没有数组的时候 就要停止定时器
                clearInterval(giftAnimation);
                this.giftAnimation = false;
              }
            }, 2000);
          } else {
          } // 正在进行动画的话 就不再添加定时器
        });
      }
    },
  },
  mounted() {

    // // 获取礼物列表
    // //获取屏幕尺寸
    // this.screenWidth = document.body.clientWidth
    // window.onresize = () => {
    //   //屏幕尺寸变化
    //   return (() => {
    //     this.screenWidth = document.body.clientWidth
    //   })()
    // }
    this.$nextTick(() => {
      let that = this;
      let myTextarea = that.$refs["inputSection"]; //chartlist输入区
      //监听键盘方向左右键
      myTextarea.addEventListener("keydown", (event) => {
        if (event.keyCode === 37) {
          event.stopPropagation();
        } else if (event.keyCode === 39) {
          event.stopPropagation();
        } else if (event.keyCode === 13) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
    
  },
  destroyed() {
    sessionStorage.setItem('destroyed', true);
  },
  methods: {
    initLivePlayer() {
      const option = this.isNativeApp
        ? Object.assign({}, this.ckplayerObject, {
          autoplay: true,
          volume: 0,
          mobileAutoFull: false,
        })
        : this.ckplayerObject;
      // eslint-disable-next-line no-undef
      const player = new Ckplayer(option);
      this.$store.commit('home/set_player', player);
      if (this.isNativeApp) {
        this.$nextTick(() => this.enableLiveVideoAutoplay(player));
      }
    },
    enableLiveVideoAutoplay(player, retry = 0) {
      const video = document.querySelector('#ckplayerVideo video');
      if (!video) {
        if (retry < 20) {
          setTimeout(() => this.enableLiveVideoAutoplay(player, retry + 1), 100);
        }
        return;
      }
      const unlockMuted = () => {
        video.muted = false;
        video.defaultMuted = false;
        video.removeAttribute('muted');
        if (video.volume === 0) {
          video.volume = 1;
        }
        const playPromise = video.play && video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(() => undefined);
        }
      };
      if (player && !player.__nativeMutePatched) {
        const videoEscMute = player.videoEscMute;
        player.volumeTemp = 1;
        player.videoEscMute = function () {
          if (typeof videoEscMute === 'function') {
            videoEscMute.call(player);
          }
          if (typeof player.changeVolume === 'function') {
            player.changeVolume(1);
          }
          unlockMuted();
        };
        player.__nativeMutePatched = true;
      }
      if (!video.__nativeMutePatched) {
        video.addEventListener('volumechange', () => {
          if (!video.muted && video.volume === 0) {
            unlockMuted();
          }
        });
        video.__nativeMutePatched = true;
      }
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.setAttribute('muted', 'muted');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', 'true');
      video.setAttribute('x-webkit-airplay', 'true');
      video.setAttribute('x5-video-player-type', 'h5');
      video.setAttribute('x5-video-orientation', 'portraint');
      const playPromise = video.play && video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => undefined);
      }
    },
    // 下载海报
    downloadsImg() {
      if (this.isNativeApp) {
        const teacherImg = document.querySelector('.teacher')
        if (teacherImg) {
          const imgPath = teacherImg.getAttribute('src')
          const fullUrl = imgPath.startsWith('http')
            ? imgPath
            : window.location.origin + imgPath.replace(/^\./, '')
          // const fullUrl = rawUrl.replace(/\.jpg$/i, '.png')
          console.log('fullUrl', fullUrl)
          if (isAndroidNative('onSaveUrlImage')) {
            window.android.onSaveUrlImage(fullUrl)
          } else if (isIOSNative()) {
            window.webkit.messageHandlers.onSaveUrlImage.postMessage(fullUrl)
          } else if (isReactNative()) {
            window.ReactNativeWebView.postMessage(JSON.stringify({ method: 'onSaveUrlImage', data: fullUrl }))
          }
        }
        this.shareDialog = false
        this.$store.commit('home/set_showVideo', true)
        return
      }
      //未入金未登录
      if (!this.userInfo.HasFirstDeposit && this.registerSuccess) {
        html2canvas(document.getElementById("sharetype"), {
          useCORS: true, //是否尝试使用CORS从服务器加载图像
          backgroundColor: 'null', //画布背景色（如果未在DOM中指定）。设置null为透明
        }).then((canvas) => {
          // 返回一个 canvas 对象，在dom中渲染 canvas 对象
          //document.body.appendChild(canvas);
          // 转化成 dataurL
          let canvasImg = canvas.toDataURL("image/png");
          //调用下载方法
          this.downLoadFile("simple", canvasImg);
        });
      } 
      // 未入金已登录
      else if (!this.userInfo.HasFirstDeposit &&  !this.registerSuccess) {
        html2canvas(document.getElementById("shareBox"), {
          useCORS: true, //是否尝试使用CORS从服务器加载图像
          backgroundColor: 'null', //画布背景色（如果未在DOM中指定）。设置null为透明
        }).then((canvas) => {
          // 返回一个 canvas 对象，在dom中渲染 canvas 对象
          //document.body.appendChild(canvas);
          // 转化成 dataurL
          let canvasImg = canvas.toDataURL("image/png");
          //调用下载方法
          this.downLoadFile("simple", canvasImg);
        });
      }
      // 已入金已登录
      else if(this.userInfo.HasFirstDeposit && !this.registerSuccess) {
        html2canvas(document.getElementById("sharetypes"), {
          useCORS: true, //是否尝试使用CORS从服务器加载图像
          backgroundColor: 'null', //画布背景色（如果未在DOM中指定）。设置null为透明
        }).then((canvas) => {
          // 返回一个 canvas 对象，在dom中渲染 canvas 对象
          //document.body.appendChild(canvas);
          // 转化成 dataurL
          let canvasImg = canvas.toDataURL("image/png");
          //调用下载方法
          this.downLoadFile("simple", canvasImg);
        });
      }
      this.shareDialog =false
      this.$store.commit('home/set_showVideo', true)

    },
    downLoadFile(fileName, canvasImg) {
      //创建一个a标签
      var a = document.createElement("a");
      //指定下载文件名称
      a.href = canvasImg;
      a.download = fileName;
      //模拟点击
      a.click();
    },


    // 分享好友
    shareVideo() {
      console.log('当前房间信息-----', this.roomInfo)
      this.$store.commit('home/set_showVideo', false)

      let randomIndex = Math.floor(Math.random() * this.titleList.length);
      this.symbolCount = this.titleList[randomIndex]
      console.log('随机数据---------', this.symbolCount)
      this.shareDialog = !this.shareDialog
      this.getInviteInfo({
        account: this.$store.state.login.userInfo.mtaccr,
      });
    },
    getInviteInfo(params) {
      getLdxActivityInfo({ ...params, platid: 1 }).then(res => {
        let inviteCode = res.Data.agentId
        this.shareTypesUrl = `https://h5pro.gxlgong.top/specialEvents/invite-reward/newRegister?utm_source=zzjz&t=3&tg=${inviteCode}`;
        console.log('邀请链接---------', this.shareTypesUrl)
      })
    },
    // 充多少送多少
    openRegister() {
      window.open("https://www.rlcproltd.net/uc/assets/deposit?token=" +JSON.parse(getSessionStorage('token')));

    },
    // 查询用户信息
    getAccountInfo(params) {
      getAccountInfoApi({ ...params, platid: 1 }).then((res) => {
        if (res.IsSuccess) {
          this.$store.commit(
            "login/set_userInfo",
            Object.assign({}, this.$store.state.login.userInfo, {
              HasFirstDeposit: res.Data.isFirst,
              IsBasicAuthentication: res.Data.authenticationMethod,
              // Uid: res.data.Uid,
            })
          );
        }
      }).catch(err => {
        console.log(err)
      });
    },

    // 获取用户积分信息
    getUserIntegral() {
      getUserIntegralData({
        mtaccr: this.userInfo.mtaccr,
  
      }).then((res) => {
        if (res.Status === 0) {
          this.userIntegral = res.content;
        }
      });
    },
    // 获取礼物列表
    getGiftData() {
      getPrezzies({
        platid: 1,
      }).then((res) => {
        if (res.Status === 0) {
          res.content.forEach(item => {
            item.select = false
          })
          this.giftList = res.content;
          console.log(this.group(this.giftList, 8))
          this.giftPage = this.group(this.giftList, 8)
        }
      });
    },
    // 处理礼物列表数据
    group(array, subGroupLength) {
      let index = 0;
      const newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
    },

    // 获取礼物排行榜
    getGiftListData(params) {
      params.platid = 1;
      const timeData = {
        addt: this.timeToTimestamp(this.weeksTime.startDateTime), // 开始时间
        addtend: this.timeToTimestamp(this.weeksTime.endDateTime), // 结束时间
      };

      getGiftList(
        Object.assign({}, params, this.s_list_active === "3" ? {} : timeData)
      ).then((res) => {
        if (res.Status === 0) {
          this.teacherFanLists = res.content;
          this.userRanking = res.userph;
          if (this.navListActive === "1") {
            this.teacherFanList = [];
            res.content.forEach((item, index) => {
              if (index !== 0 && index !== 1 && index !== 2 && index <= 9) {
                item.indexs = index + 1;
                this.teacherFanList.push(item);
              }
            });
          }
        }
      });
    },
    showSubmit() {
      this.$store.commit('home/set_showSubmit', !this.submitShow)

    },
    showLogin() {
      this.$store.commit('home/set_showLogin', !this.loginShow)

    },
    showIntergral() {
      this.$store.commit('home/set_showIntergral', !this.intergralShow)

    },
    // 小窗口显示
    async showMini() {
      const video = document.getElementById('ckplayerVideo');

      // 进入画中画时触发
      video.addEventListener('enterpictureinpicture', () => {
        console.log('进入画中画模式');
        // 更新按钮文字为 "退出画中画"
      });

      // 退出画中画时触发
      video.addEventListener('leavepictureinpicture', () => {
        console.log('退出画中画模式');
        // 恢复全屏按钮状态
      });
      try {
        if (!document.pictureInPictureElement) {
          await video.requestPictureInPicture();
        } else {
          await document.exitPictureInPicture();
        }
      } catch (error) {
        console.error('操作失败:', error);
      }
    },
    // 初始化页面
    async pageInit() {
      // 获取平台当前默认讲师
      this.$store.dispatch("home/getDefaultTeacherInfo");
      // 获取禁言列表参数数据
      console.log('当前房间信息-----', this.roomInfo)

      await this.$store.dispatch('home/getDicts', { name: 'sys_forbid_time' })
      await this.$store.dispatch('home/getDicts', { name: 'sys_forbid_reason' })
      // 进入页面获取房间列表
      await this.getRoomList()
      // 判断房间信息和用户信息是否已经存在，存在就直接更改当前房间的视频地址
      if (this.userInfo.id && this.roomInfo.id) {
        // 获取选中房间的视频流地址或者默认视频地址 设置视频流地址或者默认播放视频 isplay: true 直播中（设置视频流地址）  false 不在直播（设置默认视频地址）
        // 获取当前房间的信息
        await this.getRoomInfo(this.roomInfo)
        this.$store.commit('home/set_isplay', this.roomInfo.isplay)
        if (this.roomInfo.isplay) {
          this.$store.commit('home/set_ckplayerObject', { video: this.roomInfo.param.pcurl, poster: '', live: true })
          this.initLivePlayer()
          // vue-video-player插件，暂时废弃该方法
          // this.$store.commit('home/set_videoPlayerConfig', { sources: [{ src: this.roomInfo.param.pcurl, type: 'application/x-mpegURL' }], poster: '' })
        } else {
          // 获取默认视频信息(测试环境发现有些房间的默认播放视频的id为空，所以加了判断)
          this.roomInfo.param.efile_id ? await this.$store.dispatch('home/getRoomDefaultVideoInfo', { id: this.roomInfo.param.efile_id, type: 0 }) : ''
        }
        // 连接socket
        const params = {
          roomid: this.roomInfo.id,
          uid: this.userInfo.id
        }
        this.$store.dispatch('home/socketInit', params)
        // 获取房间在线用户列表
        await this.$store.dispatch('home/getCurrentRoomUser', {
          broomid: this.roomInfo.id
        })
        // this.roomInfo.id ? this.onPlayerPlay(this.$refs['videoPlayer'].player) : ''
      } else if (!this.roomInfo.id) {
        // 如果没有进入房间，默认进入最近一场直播的房间
        await this.enterRecentLiveRoom();
      }
    },
    // 根据课程表找到最近一场直播并进入房间
    async enterRecentLiveRoom() {
      await this.$store.dispatch('home/getTimetable', { platid: 1, sort: 'day2week,asc' });
      const list = this.$store.state.home.timeTableContent;
      if (!list || !list.length) return;

      const now = new Date();
      const today = now.getDay();
      const currentHHMM = now.getHours() * 100 + now.getMinutes();

      let prevSession = null;
      let nextSession = null;

      list.forEach(item => {
        const itemDay = Number(item.day2week);
        const itemHHMM = Number(item.intime);

        if (itemDay < today || (itemDay === today && itemHHMM <= currentHHMM)) {
          // 已经过去的场次，找最近的上一场（day越大越近，同day则time越大越近）
          if (!prevSession) {
            prevSession = item;
          } else {
            const prevDay = Number(prevSession.day2week);
            const prevHHMM = Number(prevSession.intime);
            if (itemDay > prevDay || (itemDay === prevDay && itemHHMM > prevHHMM)) {
              prevSession = item;
            }
          }
        } else {
          // 即将开始的场次，找最近的下一场（day越小越近，同day则time越小越近）
          if (!nextSession) {
            nextSession = item;
          } else {
            const nextDay = Number(nextSession.day2week);
            const nextHHMM = Number(nextSession.intime);
            if (itemDay < nextDay || (itemDay === nextDay && itemHHMM < nextHHMM)) {
              nextSession = item;
            }
          }
        }
      });

      const targetSession = prevSession || nextSession;
      if (!targetSession || !targetSession.broom) return;

      const targetRoom = this.roomList.find(r => r.id === targetSession.broom.id);
      if (!targetRoom) return;

      // 先把房间信息存入 session，游客登录后 location.reload 时可读到
      sessionStorage.setItem('roomInfo', JSON.stringify(targetRoom));

      // 游客登录：store 内部会 setSessionStorage(userInfo/token) + location.reload()
      // reload 后 pageInit 的 if(userInfo.id && roomInfo.id) 分支正常初始化视频，与 roomList 进入房间逻辑一致
      const uuid = sessionStorage.getItem('craigNewUserid') || this.generateGuestId();
      sessionStorage.setItem('craigNewUserid', uuid);
      await this.$store.dispatch('home/youkeLogin', {
        plats: [{ id: '1' }],
        signtype: '10',
        device: 'wap',
        nick: '游客' + uuid.substring(uuid.length - 4),
        username: uuid,
        utype: 0,
      });
    },
    generateGuestId() {
      let guid = '';
      for (let i = 1; i <= 32; i++) {
        guid += Math.floor(Math.random() * 16.0).toString(16);
      }
      return guid;
    },
    // accessKey免登录：地址栏携带accessKey和from参数时，用UC用户信息登录直播间
    async checkAccessKeyLogin() {
      const queryInfo = this.$route.query;
      const platFrom = queryInfo.from;
      const accessKey = queryInfo.accessKey;
      if (platFrom !== 'app_pm') return
      if(accessKey) {
        setToken(accessKey);
      } else {
        deleteToken();
        // 直接退出：清除token,userInfo,roomInfo
        setSessionStorage('token', { token: '' })
        setSessionStorage('userInfo', { id: '' })
        this.$router.replace({ path: this.$route.path })
        return
      }
      // 先用accessKey作为token请求queryUserInfo获取账号密码
      try {
        const userInfo = await queryUserInfo()
        if (!userInfo || !userInfo.account) return
        const account = userInfo.account
        const pwd = userInfo.pwd ? decryptCBC(userInfo.pwd, '1eSAaqepg71Dpj22', 'shmfdWQyrLRFBNSS') : '';
        const nick = String(account).replace(String(account).substring(2, String(account).length - 2), '****')
        const loginParams = {
          username: account,
          password: pwd,
          device: 'wap',
          signtype: 10,
          code: '',
          conner: true,
          plats: [{ id: 1 }],
          nick,
        }
        // 清除URL中的accessKey，防止页面reload后重复走该流程
        this.$router.replace({ path: this.$route.path })
        // 用account/pwd单独登录直播间（与UC登录是两套系统）
        await this.$store.dispatch('login/handleLogin', { ...loginParams, isReload: false })
      } catch (e) {
        console.error('accessKey登录失败', e)
      }
    },
    // 登录成功后处理事件(登录成功后循环获取房间信息)
    handleLoginSuccess() {
      const list = Object.assign([], this.roomList)
      list.length &&
        list.forEach(async item => {
          await this.getRoomInfo(item)
        })
      this.$store.commit('home/set_roomList', list)
      this.pageInit();
    },
    // 获取房间列表
    async getRoomList() {
      const option = {
        platid: config.platid,
        page: 0,
        size: 10
      }
      await this.$store.dispatch('home/getRoomList', option)
    },
    // craig--获取老师和课程信息
    async getTeacherInfo() {
      console.log('craig--获取老师和课程信息', this.roomInfo)
      await this.$store.dispatch('home/getTeacherInfo', { broomid: this.roomInfo.id })
    },
    // craig--获取课堂笔记列表
    async getBnotes() {
      const option = {
        broomid: this.roomInfo.id,
        tid: this.teacherInfo && this.teacherInfo[1].id,
        bsheetid: this.teacherInfo && this.teacherInfo[0].value.id,
        // bsheetid:42,
        sort: 'ut,DESC',
      }
      await this.$store.dispatch('home/getBnotes', option)
    },
    // craig--获取登录提示时间间隔
    async loginSetTime() {
      await this.$store.dispatch('home/loginSetTime', { platid: config.platid })
    },
    // craig--根据登录提示时间间隔和次数控制弹框
    craigSetTime() {
      if (this.tipTime.minute) {
        let minute = Number(this.tipTime.minute);
        console.log('============================', this.tipTime.minute);
        var timer = setTimeout(() => {
          console.log('+++++++++++++++', this.tipTime.num);
          if (Number(this.tipTime.num) > 0) {
            this.$store.commit('home/set_dialogobj4', {
              dialogVisible: true,
              isCloseIcon: true,
              width: '98%',
              gq: true,
            })
            this.$store.commit('home/set_showVideo', false)

          } else if (Number(this.tipTime.num) == 0) {
            console.log('-----------------');
            this.$store.commit('home/set_dialogobj4', {
              dialogVisible: false,
              isCloseIcon: false,
              width: '98%',
              gq: false,
            })
            this.$store.commit('home/set_showVideo', true)

            clearInterval(timer);
          }
        }, minute * 60 * 1000);
      }
    },
    // craig--判断游客是否可以发言
    async isguestmessageMethod() {
      await this.$store.dispatch('home/isguestmessage', { platid: config.platid })
    },
    // 获取房间信息
    async getRoomInfo(item) {
      console.log('房间信息----------',item)
      const option = {
        userId: this.userInfo.id || '',
        'broom.id': item.id,
        'bclass.type': 1
      }
      await this.$store.dispatch('home/getRoomInfo', option).then(res => {
        if (res.Status === 0) {
          res.liveStatus === '1' ? item.isplay = true : item.isplay = false // true直播中 false非直播中
          item.regStatus = res.regStatus || '' // 1可以报名 2 报名过期 3 已报名
          item.tId = res.tId || '' // 当前直播中老师的id
          item.classId = res.classId || '' // 可报名课程的id
          item.onLineNum = res.onLineNum || 0 // 在线人数
          item.regNum = res.regNum || '' // 报名人数
          console.log('roomInfo', this.roomInfo, item, res)
        }
      })
    },
    // 发言更多操作
    handleEvent(type, item) {
      // type:1、回复引用 2、禁言 3、私聊 4、撤回发言 5、@别人 6、礼物快速回复
      switch (type) {
        case 1:
          this.sendType = 1
          this.$refs['inputSection'].focus()
          this.handleReplyEvent(item)
          break
        case 2:
          this.handleStopEvent(item)
          break
        case 3:
          this.handlePrivateChatEvent(2, item, false, true)
          break
        case 4:
          this.handleRecallEvent(item)
          break
        case 5:
          this.sendType = 5
          this.$refs['inputSection'].focus()
          this.handleOtherPeopleEvent(item)
          break
        case 6:
          this.handleQuickReplyEvent(item)
          break
        default:
          this.sendType = 0
          break
      }
    },
    // 回复引用
    handleReplyEvent(item) {
      this.replyCall = {
        show: true,
        name: item.sname,
        txt: item.param.TXT
      }

      const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
      this.sendData = {
        broomid: this.roomInfo.id,
        sname: this.userInfo.nick || nick,
        sid: this.userInfo.id,
        rid: '',
        rname: '',
        type: 0,
        param: {
          TXT: this.sendTxt,
          CITE_TXT: item.param.TXT,
          CITE_TXT_ID: item.id,
          CITE_TXT_NAME: item.sname
        }
      }
    },
    // 关闭回复引用
    handleCloseReplyEvent() {
      this.replyCall = {
        show: false,
        name: '',
        txt: ''
      }
      const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
      this.sendData = {
        broomid: this.roomInfo.id,
        sname: this.userInfo.nick || nick,
        sid: this.userInfo.id,
        rid: '',
        rname: '',
        type: 0,
        param: {
          TXT: '',
          CITE_TXT: '',
          CITE_TXT_ID: '',
          CITE_TXT_NAME: ''
        }
      }
    },
    // 禁言
    handleStopEvent(item) {
      this.$store.commit('home/set_stopWordsUserInfo', item)
      this.$store.commit('home/set_dialogobj', {
        dialogVisible: true,
        isCloseIcon: true,
        type: 2,
        width: '500px'
      })
    },
    // 撤回发言
    handleRecallEvent(item) {
      const option = {
        broomid: this.roomInfo.id,
        type: '12',
        id: item.id,
        sid: item.sid
      }
      this.socket.send(JSON.stringify(option))
    },
    // @别人
    handleOtherPeopleEvent(item) {
      this.sendTxt = '@' + item.sname
      const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
      this.sendData = {
        broomid: this.roomInfo.id,
        sname: this.userInfo.nick || nick,
        sid: this.userInfo.id,
        rid: item.sid,
        rname: item.sname,
        type: 0,
        param: {
          TXT: this.sendTxt,
          CITE_TXT: '',
          CITE_TXT_ID: '',
          CITE_TXT_NAME: ''
        }
      }
    },
    // 获取当前用户头像 utype --> 0:普通用户 1:讲师
    getHeaderImg() {
      if (this.userInfo.utype == 0 || this.userInfo.utype == undefined) {
        return sessionStorage.getItem('headerImg') || this.imgSrc
      }
      return this.userInfo.avatar
    },
    // 礼物快速回复：自动@送礼物的客户并直接发出感谢消息
    handleQuickReplyEvent(item) {
      const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
      const option = {
        broomid: this.roomInfo.id,
        sname: this.userInfo.whoami || this.userInfo.nick || nick,
        sid: this.userInfo.id,
        rid: item.sid,
        rname: item.sname,
        type: 0,
        platid: config.platid,
        param: {
          TXT: `谢谢${item.sname}的礼物`,
          CITE_TXT: '',
          CITE_TXT_ID: '',
          CITE_TXT_NAME: ''
        },
        headerimg: this.getHeaderImg(),
      }
      this.socket.send(JSON.stringify(option))
      this.sendType = 0
    },
    onPlayerPlay(player) {
      const myPlayer = this.$refs.videoPlayer.player
      myPlayer.play()
      this.$message({
        type: 'warning',
        message: '请您自行打开视频声音'
      })
    },
    onPlayerPause(event) { },
    onPlayerEnded() {
      const list = this.$store.state.home.defaultVideoList
      const index = this.$store.state.home.defaultVideoIndex
      if (!list.length || this.$store.state.home.ckplayerObject.live) return
      const nextIndex = index + 1
      if (nextIndex < list.length) {
        const nextVideo = list[nextIndex]
        this.$store.commit("home/set_defaultVideoIndex", nextIndex);
        this.$store.commit("home/set_defaultVideoInfo", nextVideo);
        this.$store.commit("home/set_ckplayerObject", { video: nextVideo.src, live: false });
        this.$nextTick(() => {
          const video = event && event.target ? event.target : this.$refs.videoPlayer
          if (!video || typeof video.play !== 'function') return
          if (typeof video.load === 'function') {
            video.load()
          }
          const playPromise = video.play()
          if (playPromise && playPromise.catch) {
            playPromise.catch(() => undefined)
          }
        })
      }
    },
    // 房间切换按钮
    async handleRoomList() {
      await this.getRoomList()
      this.roomInfo.id ? this.$store.commit('home/set_roomtid', this.roomInfo.tId) : ''
      this.$store.commit('home/set_showroomlist', true)
    },
    // 用户列表切换按钮
    async handleUserList() {
      if (!this.userInfo.id) {
        this.$message({
          type: 'error',
          message: '请您登录，并选择房间后再查看用户列表'
        })
        return false
      } else {
        if (!this.roomInfo.id) {
          this.$message({
            type: 'error',
            message: '请您选择房间后再查看用户列表'
          })
          return false
        }
      }
      // 获取当前房间的在线用户
      await this.$store.dispatch('home/getCurrentRoomUser', {
        broomid: this.roomInfo.id
      })
      this.$store.commit('home/set_showuserlist', !this.showUserList)
      if (!this.showUserList) {
        this.$store.commit('home/set_currentroomuserlist', [])
      }
    },
    /**
     * 私聊弹出窗触发点（1、客服点击页面私聊按钮 2、客服在聊天记录中点击私聊 3、socket接收到私聊信息 4、用户列表触发私聊）
     * 此处只处理情况1和2(情况4与情况2的处理逻辑想通，只是触发是在用户列表中)，情况3放到socket中处理
     * 情况1：先请求当前客服的私聊用户列表 1-1：私聊用户列表为空，不打开私聊窗口，提示客服到聊天记录中选择一个用户去私聊；1-2私聊用户列表不为空，默认当前私聊用户信息为列表第一个用户,并请求和第一个用户的聊天记录。打开私聊窗口
     * 情况2：先请求当前客服私聊用户列表 2-1：私聊用户列表为空，将当前选中的私聊用户添加到列表中，并同时修改当前私聊用户信息为该选中用户；2-2私聊用户列表不为空，将当前用户添加到列表第一个，并修改当前默认私聊用户信息为该选中用户以及修改状态机中私聊用户列表，请求和该用户的私聊聊天记录。以上两种都需要最后打开私聊窗口（注意这种情况下需要去重处理）
     * type: 1、客服点击页面私聊按钮 2、用户在聊天记录中点击用户私聊
     * info: 选中用户的信息{ id: '', nick: ''}
     * **/
    async handlePrivateChatEvent(type, info, bool, isFalse) {
      console.log(type, info, bool, isFalse);
      if (!isFalse) {
        // 普通用户业务逻辑
        const option = {
          broomid: this.roomInfo.id,
          id: this.userInfo.id,
          platid: 1,
        }
        // 获取分配的客服
        await this.$store.dispatch('home/getDistributecustomer', option)
        // 请求和选中私聊用户的聊天记录
        if (this.distributecustomer.id) {
          const params = {
            broomid: this.roomInfo.id,
            type: 11,
            id1: this.userInfo.id,
            id2: this.distributecustomer.id,
            page: 0,
            size: 50,
          }
          await this.$store.dispatch('home/getUserPrivateChatHistoryListById', params)
          // 打开私聊窗口
          this.$store.commit('home/set_dialogobj', {
            dialogVisible: true,
            isCloseIcon: false,
            type: 3,
            width: '98%'
          })
        }
      } else {
        // 客服和讲师的业务逻辑
        this.$store.commit('home/set_ishomePrivateBtn', bool)
        if (!this.userInfo.id) {
          this.$message({
            type: 'error',
            message: '请您登录，并选择房间后再查看私聊信息'
          })
          return false
        }
        // 请求当前客服或者老师的私聊用户列表
        const option = {
          id: this.userInfo.id, // 当前登录老师或者客服id
          broomid: this.roomInfo.id // 当前所在房间id
        }
        await this.$store.dispatch('home/getUserListByManagerId', option)
        const list = Object.assign([], this.privateUserList)
        console.log(list.length);
        // 根据不同情况进行判断并处理对应逻辑
        if (type === 1) {
          if (list.length) {
            // 设置状态机当前私聊用户信息
            this.$store.commit('home/set_privateUserInfo', list[0])
            // 请求和选中私聊用户的聊天记录
            const params = {
              broomid: this.roomInfo.id,
              type: 11,
              id1: this.userInfo.id,
              id2: list[0].id,
              page: 0,
              size: 50
            }
            await this.$store.dispatch('home/getUserPrivateChatHistoryListById', params)
            // 打开私聊窗口
            this.$store.commit('home/set_dialogobj', {
              dialogVisible: true,
              isCloseIcon: false,
              type: 3,
              width: '98%'
            })
          }
        } else {
          if (list.length) {
            // 用户列表不为空，要去重，先检查列表中有没有该用户，如果有就先移除，然后把当前用户添加进去；如果没有直接添加进去
            const regList = []
            list.forEach(item => {
              regList.push(item.id)
            })
            if (regList.indexOf(info.sid) > -1) {
              list.splice(regList.indexOf(info.sid), 1)
            }
            list.unshift({ id: info.sid, nick: info.sname })
          } else {
            list.push({ id: info.sid, nick: info.sname })
          }
          // 设置私聊用户列表
          this.$store.commit('home/set_privateUserList', list)
          // 设置状态机当前私聊用户信息
          this.$store.commit('home/set_privateUserInfo', { id: info.sid, nick: info.sname })
          // 请求和选中私聊用户的聊天记录
          const params = {
            broomid: this.roomInfo.id,
            type: 11,
            id1: this.userInfo.id,
            id2: info.sid,
            page: 0,
            size: 50
          }
          await this.$store.dispatch('home/getUserPrivateChatHistoryListById', params)
          // 打开私聊窗口
          this.$store.commit('home/set_dialogobj', {
            dialogVisible: true,
            isCloseIcon: false,
            type: 3,
            width: '98%'
          })
        }
      }

    },
    // 发送事件处理(点击发送按钮)
    handleSendEvent() {
      if (this.userInfo.id == '') {
        this.$message({
          type: 'error',
          message: '请先登录后发言'
        })
        return false
      }
      if (!this.userInfo.id && !this.roomInfo.id) {
        this.$message({
          type: 'error',
          message: '请先登录并进入房间'
        })
        return false
      }
      const TXT = this.sendTxt.replace(/\s*/g, '')

      if (TXT === '') {
        this.$message({
          showClose: true,
          message: '发送内容不能为空',
          type: 'error'
        })
        return false
      } else if (TXT.length > this.roomset.content_lenth) {
        this.$message({
          showClose: true,
          type: 'error',
          message: `输入内容长度不能超过${this.roomset.content_lenth}`
        })
        return false
      }
      let option = {}
      if (this.sendType === 0) {
        const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
        var headerimg = null;
        //utype --> 0:普通用户 1:讲师
        if (this.userInfo.utype == 0 || this.userInfo.utype == undefined) {
          if (sessionStorage.getItem('headerImg')) {
            headerimg = sessionStorage.getItem('headerImg');
          } else {
            headerimg = this.imgSrc;
          }
        } else {
          headerimg = this.userInfo.avatar;
        }
        option = {
          broomid: this.roomInfo.id,
          sname: this.userInfo.whoami || this.userInfo.nick || nick,
          sid: this.userInfo.id,
          type: 0,
          platid: config.platid,
          param: {
            TXT: this.sendTxt.replace('@' + this.sendData.rname, '')
          },
          headerimg,
        }
        option = Object.assign({}, option)
      } else {
        const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
        var headerimg = null;
        //utype --> 0:普通用户 1:讲师
        if (this.userInfo.utype == 0 || this.userInfo.utype == undefined) {
          if (sessionStorage.getItem('headerImg')) {
            headerimg = sessionStorage.getItem('headerImg');
          } else {
            headerimg = this.imgSrc;
          }
        } else {
          headerimg = this.userInfo.avatar;
        }
        option = {
          broomid: this.roomInfo.id,
          sname: this.userInfo.whoami || this.userInfo.nick || nick,
          sid: this.userInfo.id,
          type: 0,
          platid: config.platid,
          param: {
            TXT: this.sendTxt.replace('@' + this.sendData.rname, ''),
            CITE_TXT: this.sendData.param.CITE_TXT,
            CITE_TXT_ID: this.sendData.param.CITE_TXT_ID,
            CITE_TXT_NAME: this.sendData.param.CITE_TXT_NAME
          },
          headerimg,
        }
        option = Object.assign({}, this.sendData, option)
      }
      console.log(option,this.socket);
      this.socket.send(JSON.stringify(option))
      this.sendTxt = ''
      this.replyCall = {
        show: false,
        name: '',
        txt: ''
      }
      this.sendType = 0
    },
    // 关闭弹出层
    handleCloseDialog() {
      this.$store.commit('home/set_dialogobj', { dialogVisible: false, isCloseIcon: true })
      this.$store.commit('home/set_showVideo', true)

    },
    handleCloseDialog4() {
      this.$store.commit('home/set_dialogobj4', { dialogVisible: false, isCloseIcon: true });
      let num = Number(this.tipTime.num);
      let data = {
        minute: this.tipTime.minute,
        num: num - 1,
      };
      this.$store.commit('home/set_tipTime', data);
    },
    // 关闭弹出层
    handleCloseDialog3() {
      this.$store.commit('home/set_dialogobj3', { dialogVisible: false, isCloseIcon: true })
      this.$store.commit('home/set_showVideo', true)

    },
    // 点击空表部分隐藏用户列表和房间列表
    handleGolbalEvent(event) {
      this.$store.commit('home/set_showuserlist', false)
      this.giftsSHow = false

    },
    handleOut(event) {
      this.$store.commit('home/set_showroomlist', false)
      this.$store.commit('home/set_showVideo', true)

    },
    handleHistory(){
        this.$store.commit('home/set_showhistory', false)

    },
    handlemyprint(){
      this.$store.commit('home/set_showmyPrint', false)

    },
    // 点击送礼物外部区域
    handleGift(event) {
      this.giftsSHow = false
    },
    // 更多区域点击
    handleMore(event) {
      this.showList = false
    },
    // 公聊屏幕滚动和冻结
    handleAutoScroll(bool) {
      this.$store.commit('home/set_isatuoscroll', bool)
    },
    // 关闭注册成功之后的dialog
    closerDialog() {
      this.craigDialog.registerVisible = false;
      this.$store.dispatch("login/handleLogin", this.registerAfterInfo);
      this.$store.commit("login/set_registerAfterInfo", "");
      clearInterval(this.timer);
    },
    // 点击选择器
    selectShow(attr) {
      if (!this.userInfo.id && !this.roomInfo.id) {
        this.$message({
          type: 'error',
          message: '请先登录并进入房间'
        })
        return false
      }
      this.controlClass = attr;
      this.$store.commit('home/set_selectTree', attr);
      this.controlShowChat = !this.controlShowChat
    },
    // 跳转登录
    handleLogin(attr) {
      if(this.isNativeApp) {
        if(isAndroidNative('gotoLogin')) {
          window.android.gotoLogin();
          return
        }
        if(isIOSNative()) {
          window.webkit.messageHandlers.gotoLogin.postMessage('1');
          return
        }
        if(isReactNative()) {
          const message = JSON.stringify({ method: 'gotoLogin' });
          window.ReactNativeWebView.postMessage(message);
          return
        }
        return
      }
      this.$store.commit('home/set_dialogobj', {
        dialogVisible: true,
        isCloseIcon: false,
        type: 1,
        width: '98%'
      }),
        this.$store.commit('home/set_dialogobj4', { dialogVisible: false, isCloseIcon: true })
      if (attr === 1) {
        this.$store.commit('login/set_activeName', 'second');
      } else if (attr === 2) {
        this.$store.commit('login/set_registerStatus',false)
        this.$store.commit('login/set_activeName', 'first');
      } else {
        this.$store.commit('login/set_registerStatus', false)
        this.$store.commit('home/set_showVideo', false)

        this.$store.commit('login/set_activeName', 'second');
        this.$store.commit('home/set_dialogobj', {
          dialogVisible: true,
          isCloseIcon: true,
          type: 1,
          width: '98%'
        });

      }
    },
    // 跳转客服链接
    live800() {
      // this.liveBody = !this.liveBody;
      this.unreadNum = 0
      this.showList = !this.showList
      this.$store.commit('home/set_showVideo', false)
      this.$store.commit('home/set_showRed', false);
      console.log('我的信息', this.userInfo);
      if (this.userInfo.utype == 0) {
        this.handlePrivateChatEvent(1, {}, true, false);
      } else {
        this.handlePrivateChatEvent(1, {}, true, true);
      }
    },
    // 在线客服
    toRequest() {
      this.showList = false
      if (this.isNativeApp) {
        this.showServicePage = true
      } else {
        window.open(this.live800Url)
      }
    },
    // 点击头像事件
    tag(q, m) {
      this.control.target = q;
      this.control.realImg = m;
    },
    // 点击更换头像
    changeImg() {
      sessionStorage.setItem('headerImg', this.control.realImg);
      this.control.headerImg = this.control.realImg;
      this.control.showDiv = false;
    },
    onSlideClick() {
      const swiperInstance = this.$refs.swiperGift.swiper;
      swiperInstance.autoplay.stop();
   
    },

    // ---------------------------------------------送礼物--------------------
    pauseSwiper() {
      this.$refs.swiperGift.swiper.autoplay.stop()
    },
    resumeSwiper() {
      this.$refs.swiperGift.swiper.autoplay.start()
    },
    // 礼物选择
    selectGift(e) {
      console.log('礼物id---------', e)
      if (this.userIntegral.point < e.resourcesnum) {
        this.interGrals = true
      } else {
        this.interGrals = false
      }
      this.selectindex = e.id
      this.giftinfo = e

    },
    

    // 送出礼物
    sendGifts() {
      this.giftsSHow = !this.giftsSHow
      this.sendShow = !this.sendshow
      // 礼物展示
      this.DisplayShow = true
      setInterval(this.updateShow, 4000);

    },

    // 送出礼物展示
    updateShow() {
      this.sendShow = false
      this.DisplayShow = false
    },
    // 赠送礼物事件
    giveGift(gift) {
      console.log('送出礼物------------------', this.userInfo, this.teacherInfo)
      let host = location.host;
      // 未登录  提醒去登录
      if (
        !this.userInfo.id ||
        this.$store.state.login.userInfo.nick.indexOf("游客") !== -1
      ) {
        // this.loginShow=!this.loginShow
        this.$store.commit('home/set_showLogin', !this.loginShow)

        this.handleLogin(1);
        return;
      }
      // 已登录 未基础认证
      if (!this.userInfo.IsBasicAuthentication) {
        if(this.isNativeApp) {
          if(isAndroidNative('gotoCertification')) {
            window.android.gotoCertification();
            return
          }
          if(isIOSNative()) {
            window.webkit.messageHandlers.gotoCertification.postMessage('1');
            return
          }
          if(isReactNative()) {
            const message = JSON.stringify({ method: 'gotoCertification' });
            window.ReactNativeWebView.postMessage(message);
            return
          }
          return
        }
        if (
          host.indexOf("localhost") > -1 ||
          host.indexOf(".lan") > -1 ||
          host.indexOf("8080") > -1 ||
          host.indexOf("testwww.rlc525") > -1
        ) 
        {
          this.$store.commit('home/set_showSubmit', !this.submitShow)

          // window.location.href =
          //   "http://test.www.rlcvipltd.com/uc/userCenter/userInfo";
        } else {
          this.$store.commit('home/set_showSubmit', !this.submitShow)

          // window.location.href =
          //   "https://www.rlcproltd.net/uc/userCenter/userInfo";
        }
        
        return;
      }
      // 已登录  未入金
      if (!this.userInfo.HasFirstDeposit) {
        if(this.isNativeApp) {
          if(isAndroidNative('gotoDeposit')) {
            window.android.gotoDeposit();
            return
          }
          if(isIOSNative()) {
            window.webkit.messageHandlers.gotoDeposit.postMessage('1');
            return
          }
          if(isReactNative()) {
            const message = JSON.stringify({ method: 'gotoDeposit' });
            window.ReactNativeWebView.postMessage(message);
            return
          }
          return
        }
        if (
          host.indexOf("localhost") > -1 ||
          host.indexOf(".lan") > -1 ||
          host.indexOf("8080") > -1 ||
          host.indexOf("testwww.rlc525") > -1
        ) {
          window.location.href =
            "http://test.www.rlcvipltd.com/uc/assets/deposit";
        } else {
          window.location.href = "https://www.rlcproltd.net/uc/assets/deposit";
        }
        return;
      }
      // 判断用户积分是否足够
      // gift.type === 1
      if (this.userIntegral.point < this.giftinfo.resourcesnum) {
        this.$store.commit('home/set_showIntergral', !this.intergralShow)
       
        return;
      }
      //teacherinfo[1].id
      if (!this.teacherInfo) {
        this.$message({
          type: 'warning',
          message: '当前直播间暂无直播课程'
        })
        return
      }
      // 送礼物
      giveGiftList({
        userid: this.userInfo.id,
        giftid: this.giftinfo.id,
        tid: this.teacherInfo[1].id,
        tname: this.teacherInfo[1].whoami,
        broomid: this.roomInfo.id,
        platid: 1,
      }).then((res) => {
        if (res.Status === 0) {
          this.giftsSHow = false
          this.selectindex = null
          const keys = "popover-" + this.giftinfo.id; //当前ref的keygifts
          let headerimg = null;
          //utype --> 0:普通用户 1:讲师
          if (this.userInfo.utype == 0 || this.userInfo.utype == undefined) {
            if (sessionStorage.getItem('headerImg')) {
              headerimg = sessionStorage.getItem('headerImg');
            } else {
              headerimg = this.imgSrc;
            }
          } else {
            headerimg = this.userInfo.avatar;
          }
          console.log('res', res, headerimg);
          const nick = String(this.userInfo.mtaccr).replace(String(this.userInfo.mtaccr).substring(2, String(this.userInfo.mtaccr).length - 2), '****')
          let option = {
            id: res.content.id,
            sname: this.userInfo.whoami || this.userInfo.nick || nick,
            sid: this.userInfo.id,
            msgtype: "gift",
            gift: this.giftinfo.id,
            param: {
              // 礼物名称和图片包成 JSON 字符串发送
              TXT: JSON.stringify({
                giftid: this.giftinfo.id,
                giftname: this.giftinfo.name,
                gifticon: this.giftinfo.icon,
                goldpoint: this.giftinfo.goldpoint,
                num: 1,
                tname: this.teacherInfo[1].whoami,
              }),
            },
            headerimg,

          };
          // 给服务端推送送礼物消息
          this.socket.send(JSON.stringify(option));
          // 礼物赠送成功重新刷新用户自己积分
          this.getUserIntegral();
        }
      });
    },
    // 礼物记录
    searchHistory() {
      this.showList = !this.showList
      this.$store.commit('home/set_showhistory',true)
      // this.$router.push({
      //   name: 'giftHistory'
      // })
    },
    // 我的晒单
    toMyprint() {
      this.$store.commit('home/set_showmyPrint', true)

      this.showList = !this.showList

      // this.$router.push({
      //   name: 'myPrint'
      // })
    },

    // 晒单
    printOut() {
      this.$router.push({
        name: 'printOut'
      })
    },
    // 去登录
    toLogin() {

    },
    // 去激活
    toSubmit() {
      let host = location.host;

      if (
        host.indexOf("localhost") > -1 ||
        host.indexOf(".lan") > -1 ||
        host.indexOf("8080") > -1 ||
        host.indexOf("testwww.rlc525") > -1
      ) {
        this.submitShow = !this.submitShow
        window.location.href =
          "http://test.www.rlcvipltd.com/uc/userCenter/userInfo";
      } else {
        this.submitShow = !this.submitShow

        window.location.href =
          "https://www.rlcproltd.net/uc/userCenter/userInfo";
      }
    },

    //选择表情包
    addEmoji(e) {
      this.sendTxt += e.native;
      this.showEmoji = false
    },

  }
}
</script>

<style lang="less">
.classRoomBox {
  position: relative;

  .wapTab {
    width: 100%;
    height: auto;
    position: fixed;
    top: 0;
    z-index: 999;
  }
}

.home-page {
  background: #fff;
  padding: 0 0 0px 0;
  overflow-y: auto;
  margin-top: 45px;

  /**主内容区域**/
  .home-page-main {
    display: flex;
    // flex-flow: row nowrap;
    // justify-content: flex-start;
    // margin-top: 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    .main-header {
      height: 45px;
      line-height: 45px;
    }
  }

  .el-card__body,
  .el-main {
    padding: 0 !important;
  }

  /**主内容区域左边**/
  .video-section {
    // flex: 1;
    // position: relative;
    width: 100%;
    position: fixed;
      top: 7%;
      left: 0;

    .video-header {
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0px;
      box-sizing: border-box;

      // padding: 10px 0;
      .changeBox {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 130px;

        .room-change-btn {
          width: 70px;
          cursor: pointer;
        }
      }
    }

    .video-sec {
      width: 100%;
      height: 220px;
      cursor: pointer;
    }
  }

  /**播放器**/
  .video-main {
    height: 220px;
    position: relative;
    border-right: 1px solid #eff3f5;
    background: #000000;
  }

  .livingavatar {
    position: absolute;
    left: 20px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #EE2547;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 1px solid #EE2547;
    }
  }

  /**讲师介绍模块 */
  .teacherIntroduce {
    width: 100%;
  }
  
  .noticeBox {
    width: 100%;
  }

  /**主内容区域右边**/
  .chat-container {
    // float: right;
    width: 100%;
    background: #ffffff;
    min-width: 300px;
    margin-bottom: 45px;
        position: fixed;
          top: 17rem;
         

    .chat-header {
      background: #ffffff;
      display: flex;
      flex-flow: row nowrap;
      justify-content: flex-start;

      // border-bottom: 1px solid #c6c6c6;
      .chat-header-left {

        .user-list-btn,
        .user-list-up-btn {
          display: inline-block;
          width: 16px;
          height: auto;
          cursor: pointer;
          margin: 17px 0 0 20px;
        }
      }

      .chat-header-right {
        width: 100%;
        position: relative;
        // flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        font-size: 14px;
        background-color: #f7f8fa;

        .chat-header-line {
          position: absolute;
          bottom: -1px;
          left: 0;
          right: 0;
          margin: auto;
          width: 104px;
          height: 2px;
          background: #3498db;
        }

        span {
          display: inline-block;
          width: 50%;
          height: 100%;
          cursor: pointer;
          color: #000;
          font-weight: 600;
        }

        .currentSpan {
          color: #EE2547;
          font-weight: 600;
          border-bottom: 4px solid #ee2547;
        }
      }

      .chat-header-living {
        width: 49px;
        height: 49px;
        text-align: center;
        line-height: 49px;
        cursor: pointer;

        img {
          width: 30px;
          height: 30px;
          margin-top: 8px;
        }
      }
    }
  }

  /**房间列表**/
  .room-list {
    width: 80%;
    position: fixed;
    top: 28rem;
    left: 61%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    box-shadow: 0px 5px 20px #c3c6c8;
    z-index: 5;
    border-radius: 5px;
  }

  /**聊天区域**/
  .chat-main {
    position: relative;
    height: auto;
    border-left: 1px solid #eff3f5;
    background: #f7f7f7;
  }

  /**用户列表**/
  .user-list {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
  }

  /**聊天区域**/
  .chat-section {
    position: relative;
    // height: 600px;
    // background-color: #f7f7f7;
  }

  /*弹窗**/
  .dialog-close {
    position: absolute;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    top: -48px;
    right: -55px;
    background: url("./assets/images/dialog-close-icon.png") no-repeat center center;
    background-size: contain;
    cursor: pointer;
  }

  /**房间列表和用户列表显示隐藏动画**/
  .fade-enter-active,
  .fade-leave-active {
    // transition: top 0.3s;
  }

  .fade-enter,
  .fade-leave-active {
    top: -1000px;
  }

  .video-js .vjs-big-play-button {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    height: 3em;
    line-height: 3em;
    border-radius: 1.5em;
  }

  .vjs_video_3-dimensions.vjs-fluid {
    padding-top: 700px;
  }

  .video-player,
  .vjs-custom-skin {
    height: 100%;
  }

  .video-js.vjs-fluid,
  .video-js.vjs-16-9,
  .video-js.vjs-4-3 {
    height: 100%;
  }

  .vjs-tech {
    max-height: 700px !important;
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
    padding-bottom: 15px;
  }

  .registerBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .registerSuccess {
      margin: 30px auto;
    }

    .registerCenter {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      .registerCenterLeft {
        width: 40%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p {
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          padding: 10px;
          background-color: #d0081d;
          margin-bottom: 5px;

          img {
            width: 115px;
          }

          span {
            color: #fff;
            margin-top: 10px;
          }
        }

        button {
          width: 130px;
          height: 30px;
          border: 1px solid #8f9091;
          background: none;
          border-radius: 12px;
          margin-top: 10px;
        }
      }

      .registerCenterRight {
        width: 60%;
        height: 300px;
        box-sizing: border-box;
        padding-right: 25px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        line-height: 24px;

        p {
          width: 240px;
          height: 80px;
          background-color: #f7f7f7;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          box-sizing: border-box;
          padding-left: 20px;
          margin: 10px 0;

          span {
            color: #000000;
            font-size: 17px;
            font-weight: 510;
          }
        }
      }
    }

    .registerButton {
      width: 85%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      p {
        width: 170px;
        height: 45px;
        border: 1px solid #ee2547;
        color: #ee2547;
        border-radius: 7px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      p:nth-child(2) {
        background-color: #ee2547;
        color: #fff;
      }
    }
  }

  .dialog-craigNew {
    .craigNewP {
      width: 100%;
      height: 80px;
      background-color: #2c2c2c;
      color: #ffffff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 30px;
      box-sizing: border-box;
      font-size: 20px;
    }

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 15px 0 20px;

      h3 {
        color: #000000;
        font-size: 20px;

        span {
          color: #ee2547;
        }
      }

      p {
        margin-bottom: 20px;
        font-size: 17px;
      }

      button {
        width: 80%;
        height: 55px;
        border: 1px solid #ee2547;
        background: none;
        color: #ee2547;
        border-radius: 5px;
        margin-top: 15px;
        font-size: 17px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 50px;
          margin-right: 5px;
        }
      }

      button:nth-child(4) {
        background-color: #ee2547;
        color: #fff;
      }
    }
  }
}

.giftDisply {
  position: absolute;
  top: 40%;
  left: 30%;

  img {
    width: 148px;
    height: 220px;

  }
}
// 礼物记录
.gifthistory{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 326px;
  border-radius: 12px 12px 0  0;
  z-index: 99;

}
.myprint{
  position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 340px;
    border-radius: 12px 12px 0 0;
    z-index: 99;
}
.wapBottom {
  width: 100%;
  position: fixed;
  bottom: 0;

  .chat-handler {
    width: 100%;
    height: 45px;
    box-sizing: border-box;
    padding: 0 15px;
    background-color: #f7f8fa;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;

    .eyes {
      width: 25px;
      height: 15px;
      margin-right: 10px;
    }

    .scroll-control {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;

      img {
        width: 24px;
        height: auto;
        cursor: pointer;
        margin-right: 12px;
        margin-left: 15px;
      }

      p {
        position: relative;

        span {
          position: absolute;
          top: 0;
          right: 3px;
          width: 4px;
          height: 4px;
          background-color: #ee2547;
          border-radius: 50%;
        }
      }

      ul {
        width: 80px;
        position: absolute;
        bottom: 35px;
        left: -50%;
        background-color: #fff;
        box-shadow: 1px 1px 10px #bfc0c4;
        border-radius: 3px;

        li {
          font-size: 12px;
          border-bottom: 1px solid #f1f1f1;
          box-sizing: border-box;
          padding: 5px 0 5px 10px;
          color: #666666;
          cursor: pointer;
        }

        li:last-child {
          border-bottom: none;
        }

        .liRed {
          color: #ee2547
        }
      }
    }

    .scroll-controls {
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;


      ul {
        width: 80px;
        position: absolute;
        bottom: 35px;
        left: -50%;
        background-color: #fff;
        box-shadow: 1px 1px 10px #bfc0c4;
        border-radius: 3px;

        li {
          font-size: 12px;
          border-bottom: 1px solid #f1f1f1;
          box-sizing: border-box;
          padding: 5px 0 5px 10px;
          color: #666666;
          cursor: pointer;
        }

        li:last-child {
          border-bottom: none;
        }

        .liRed {
          color: #ee2547
        }
      }
    }

    .headerBox {
      margin-right: 10px;

      .showHeaderImg {
        width: 30px;
        margin-left: 4px;
      }

      .positionBox {
        width: 90%;
        height: auto;
        position: absolute;
        bottom: -125%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 3;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 10px 0 10px;
        border-radius: 5px;
        box-shadow: 1px 1px 10px rgb(179, 176, 176);

        .closer {
          width: 12px;
          height: 12px;
          position: absolute;
          top: 5px;
          right: 5px;
        }

        p {
          width: 100%;
          flex-wrap: wrap;
          display: flex;
          justify-content: center;

          img {
            width: 40px;
            margin: 8px;
            cursor: pointer;
          }

          .borderImg {
            border: 2px solid #ee2547;
            border-radius: 50%;
          }
        }

        span {
          width: 35%;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ee2547;
          border-radius: 3px;
          color: #ffffff;
          cursor: pointer;
          font-size: 12px;
        }
      }
    }

    .noLogin {
      margin-right: 5px;

      img {
        width: 21px;
      }
    }


    /**输入区域**/
    .send-section {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .send-input {
        height: 40px;
        width: 100%;

        textarea {
          width: 94%;
          height: 40px;
          border: none;
          outline: none;
          resize: none;
          margin: 0;
          box-sizing: border-box;
          padding: 5px 10px 10px 10px;
          border: 1px solid #EFEFEF;
          border-radius: 40px;
        }

        .textareaTip {
          cursor: pointer;
          position: absolute;
          top: 60%;
          left: 46%;
          transform: translate(-50%, -75%);
          color: #a7a4a4;
          font-size: 13px;
        }

        .emoj {
          position: absolute;
          cursor: pointer;
          top: 12px;
          left: 60%;
          width: 24px;
          height: auto;
        }
      }

      .native-send-btn {
        flex-shrink: 0;
        height: 30px;
        line-height: 30px;
        padding: 0 14px;
        background-color: #e90014;
        color: #fff;
        font-size: 14px;
        border-radius: 20px;
        white-space: nowrap;
        cursor: pointer;
        margin-right: 15px;
      }


      // 送礼物
      .gift {
        .giftsContent {
          background: #1A191E;
          width: 100%;
          height: 342px;
          padding: 14px 12px 33px 12px;
          border-radius: 10px 10px 0 0;
          box-sizing: border-box;
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 6666;

        }

        .swiperGift {
          width: 100%;
          height: 254px;
          // position: absolute;
          // bottom: -60%;
          // left: 50%;
          // transform: translate(-50%, -50%);
          position: relative;

          .swiper-pagination {
            position: absolute;
            bottom: 31%;
            z-index: 10;
            left: 0%;
          }

          .swiper-pagination-bullet {
            background: #fff;
          }

          .swiper-container {
            width: 100%;
            height: 342px;

            .swiper-wrapper {
              .swiper-slide {
                .gifts-list {

                  display: flex;
                  flex-wrap: wrap;
                  align-items: center;
                  justify-content: space-between;
                  justify-content: flex-start;
                  position: relative;

                  .gifts {
                    width: 25%;
                    height: 100px;
                    font-size: 12px;
                    line-height: 16px;
                    padding: 13px 0 4px;
                    box-sizing: border-box;
                    color: #fff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-bottom: 12px;
                  }

                  .gifts1 {
                    border: 1px solid #464646;
                    background: #292929;
                    padding-top: 5px;

                    position: relative;

                  }

                  .gift-name {
                    width: 100%;
                    height: 28px;
                    border-radius: 0 0 4px 4px;
                    //  background: linear-gradient(90deg, #1E2C84 6.28%, #2C3FB9 77.38%);
                    background: linear-gradient(96.98deg, #FF7C92 0%, #EE2547 100%);
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    font-size: 12px;
                    color: #fff;
                    font-weight: 500;
                    text-align: center;
                    line-height: 28px;
                  }

                  .gift-names {
                    background: linear-gradient(96.98deg, #AAAAAA 0%, #7D7D7D 100%);
                  }

                  .gift-title {
                    margin: 8px 0 4px 0;
                  }

                  .gift-inter {
                    font-size: 10px;
                    color: #DDDDDD66;
                  }

                  .icon {
                    width: auto;
                    height: 40px;
                    margin-right: 0;
                  }
                }

              }
            }

            .swiper-slide-active,
            .swiper-slide-duplicate-active {

              .gifts-list {

                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                position: relative;

                .gifts {
                  width: 80px;
                  height: 100px;
                  font-size: 12px;
                  line-height: 16px;
                  padding: 13px 0 4px;
                  box-sizing: border-box;
                  color: #fff;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  margin-bottom: 12px;
                }

                .gifts1 {
                  border: 1px solid #464646;
                  background: #292929;
                  padding-top: 5px;

                  position: relative;

                }

                .gift-name {
                  width: 80px;
                  height: 28px;
                  border-radius: 0 0 4px 4px;
                  background: linear-gradient(90deg, #1E2C84 6.28%, #2C3FB9 77.38%);
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  font-size: 12px;
                  color: #fff;
                  font-weight: 500;
                  text-align: center;
                  line-height: 28px;
                }

                .gift-title {
                  margin: 8px 0 4px 0;
                }

                .gift-inter {
                  font-size: 10px;
                  color: #DDDDDD66;
                }

                .icon {
                  width: auto;
                  height: 40px;
                  margin-right: 0;
                }
              }
            }
          }
        }

        .swiperBox {
          width: 100%;
          height: 300px;

          .swiper-container {
            width: 100%;
            height: 300px;

            .swiper-wrapper {
              .swiper-slide {
                img {
                  height: 140px;
                  object-fit: cover;
                }

                .one {
                  display: block;
                }

                .two {
                  display: none;
                }

                .flex {
                  width: 100%;
                  display: flex;
                  align-items: center;
                }

                .contents {
                  background: #fff;
                  padding: 15px 12px 40px;
                  width: 219px;
                  height: 300px;
                  box-sizing: border-box;

                  .pen {
                    width: 18px;
                    height: 15px;
                  }

                  .titles {
                    font-size: 11px;

                    font-weight: 700;
                    text-align: left;
                    color: #f00000;
                    line-height: 20px;
                  }

                  .titles1 {
                    font-size: 10px;

                    font-weight: 400;
                    text-align: left;
                    color: #f00000;
                    line-height: 18px;
                    margin: 8px 0 12px;
                  }

                  .introduce {
                    font-size: 11px;

                    font-weight: 700;
                    text-align: left;
                    color: #1a1a1a;
                    line-height: 20px;
                  }

                  .cont {
                    font-size: 10px;
                    height: 154px;
                    font-weight: 400;
                    text-align: left;
                    color: #999999;
                    line-height: 18px;
                    margin-top: 8px;
                    box-sizing: border-box;
                  }
                }

                .content-box {
                  display: flex;
                  align-items: center;
                }

                .bott {
                  width: 225px;
                  height: 25.5px;
                  font-size: 9px;

                  font-weight: 400;
                  text-align: center;
                  color: #cccccc;
                  line-height: 16px;
                  margin: 15px 0 24px 0;
                }

                .bottom-text {
                  margin: 12px 0 24px;
                  font-size: 9px;

                  font-weight: 700;
                  text-align: center;
                  color: #fff;

                  span {
                    color: #f00000;
                  }
                }

                /* Center slide text vertically */
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;
                transition: 300ms;
              }

              .swiper-slide-active,
              .swiper-slide-duplicate-active {
                img {
                  height: 300px;
                }

                .two {
                  display: block;
                }

                .one {
                  display: none;
                }
              }
            }
          }
        }

        .intergral {
          // width: 351px;
          width: 93%;
          height: 54px;
          padding: 9px 16px;
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid #666666;
          position: absolute;
          bottom: 33px;
          left: 12px;
          z-index: 666;
          font-size: 12px;
          color: #fff;
          line-height: 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #444444;

          .lefts {
            display: flex;
            flex-direction: column;
          }

          .sendbox {
            min-width: 102px;
            height: 36px;
            padding: 0 8px;
            box-sizing: border-box;
            flex-shrink: 0;
            white-space: nowrap;
            border-radius: 8px;
            background: #EE2547;
            text-align: center;
            line-height: 36px;
            font-size: 13px;
          }

          .sendbox1 {
            background: linear-gradient(277.1deg, #787878 0%, #ACACAC 100%);
          }


        }

        .gift-dialog {
          background: #3A3B43;
          width: 258px;
          height: 48px;
          border-radius: 8px;
          font-size: 14px;
          line-height: 20px;
          color: #fff;
          position: absolute;
          top: 20%;
          left: 10%;
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            color: #EE2547;
          }

          .closers {
            width: 18px;
            height: 18px;
            position: absolute;
            top: -6px;
            right: -13px;
          }

        }

        .dialog1 {
          width: 192px;
          position: absolute;
          top: 44%;
          left: 20%;
        }

        .dialog2 {
          width: 206px;
          position: absolute;
          top: 68%;
          left: 20%;
        }

        img {
          width: 26px;
          height: auto;
          cursor: pointer;
          margin-right: 12px;
        }
      }

      .more {
        margin-top: 4px;
        .message {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 8px;
          height: 8px;
          background: #FE2C55;
          border-radius: 50%;
        }

        img {
          width: 24px;
          height: auto;
          cursor: pointer;
          // margin-right: 12px;
        }
      }

      // 更多区域
      .more-list {
        width: 100%;
        height: 120px;
        background: #fff;
        padding: 16px 30px 0;
        box-sizing: border-box;
        border-radius: 12px 12px 0px 0px;
        position: absolute;
        left: 0;
        bottom: 0;
        font-size: 11px;
        line-height: 15px;
        display: flex;
        // align-items: center;
        justify-content: space-between;
        // border-top: 1px solid #666666;
        color: #666;
        font-size: 10px;
        img {
          width: 18px;
          height: 18px;
          
        }
        .small{
          width: 20px;
          height: auto;
        }
        .print{
          width: 16px;
          height: 18px;
        }
        .chatimg {
          width: 22px;
          height: auto;
        }

        .listbox {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
         .iconbox{
          width: 42px;
          height: 42px;
          background: #F4F7FF;
          border-radius: 50%;
           display: flex;
           align-items: center;
           justify-content: center;
           margin-bottom: 8px;
         }
        .chats {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
           
          .message {
            position: absolute;
            top: 0;
            right: 0;
            width: 8px;
            height: 8px;
            background: #FE2C55;
            border-radius: 50%;
          }
        }
      }
    }
  }

  //送礼物记录区域
  .send-show {
    // width: 244px;
    max-width: 70%;
    // height: 32px;
    font-size: 14px;
    padding: 10px 20px;
    border-radius: 20px;
    box-sizing: border-box;
    font-weight: 500;
    color: #fff;
    display: flex;
    align-items: center;
    margin-left: 26px;
    margin-bottom: 16px;
    background: linear-gradient(90deg, #EE2547 0%, rgba(238, 37, 71, 0) 100%);
    position: relative;
    animation: slideInLeft 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;

    .avatar {
      width: 40px;
      height: 40px;
      position: absolute;
      left: -10px;
      top: -5px;
      border-radius: 50%;
      object-fit: cover;
    }

    .avatar + span {
      padding-left: 24px;
    }

    .send-cont {
      position: absolute;
      right: 0;
      top: -8px;
      display: flex;
      align-items: center;
    }

    .send-gift {
      color: #FF3156;
      font-weight: 600;
    }

    .send-img {
      width: auto;
      height: 48px;
      transform: rotate(30deg);
    }

    .send-number {

      font-size: 18px;
      font-style: italic;
      font-weight: 600;
      line-height: 22px;
      text-align: left;
      color: #FF4D00;


    }


  }

  @keyframes slideInLeft {
    from {
      transform: translateX(-100%);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .item:hover {
    transform: translateX(0%);
    opacity: 1;
  }

  /**回复引用展示区域**/
  .reply-section {
    position: absolute;
    bottom: 110px;
    left: 0;
    width: 100%;
    font-size: 12px;
    padding: 10px 15px;
    background: #fbf5ee;

    span {
      color: #8c99a5
    }

    p {
      max-width: 410px;
      color: #8c99a5;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .class-reply-btn {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 15px;
      height: 15px;
      background: #8c99a5 url('./assets/images/private-close-icon.png') no-repeat center center;
      background-size: 8px 8px;
      cursor: pointer;
      border-radius: 50%;
    }
  }

  // ***********************小窗口区域
  .miniVideo {
    width: 220px;
    height: 140px;
    border-radius: 8px;
    position: fixed;
    right: 0;
    bottom: 10%;
    background: #000;
  }
}


.loginDialogs {


  position: relative;
  position: fixed;
  top: 33%;
  left: 50%;
  transform: translate(-50%, -50%);

  /deep/ .el-dialog__body {


    border: none !important;
    width: 332px !important;
    height: 150px !important;
    background: none !important;
  }

  .shareImg {
    width: 300px;
    height: auto;
  }

  #sharetype {
    // height: 566px;
    
    margin-top: 60px;
    padding: 30px 24px;
    border-radius: 12px 12px 0 0;
    height: auto;
    box-sizing: border-box;
    display: flex;
      align-items: center;
      justify-content: center;

  .teacher {
      border-radius: 12px 12px 0 0;
        width: 297px;
        height: 512px;
    }
  
  
    .sharebottom {
      width: 80px;
      height: 80px;
  
      position: absolute;
          right: 40px;
            bottom: 3%;
  
    }

    

   
  }
    #shareBox {
      margin-top: 60px;
      background-size: 100% 100%;
      border-radius: 12px 12px 0 0;
      height: auto;
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      .teacher{
        border-radius: 12px 12px 0 0;
        width: 297px;
        height: 512px;
      }
      
  
      .sharebottom {
        width: 80px;
        height: 80px;
  
        position: absolute;
        right: 40px;
        bottom: 3%;
  
      }
  
     
    }
  #sharetypes {
    margin-top: 60px;
    // height: 566px;
    // background: url("./assets/images/gifts/sharebg2.png") no-repeat center center;
    background-size: 100% 100%;
    // padding: 30px 24px;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
      align-items: center;
      justify-content: center;

  .teacher {
      border-radius: 12px 12px 0 0;
        width: 297px;
        height: 512px;
    }
  
  
    .sharebottom {
      width: 80px;
      height: 80px;
  
      position: absolute;
      right: 20px;
      bottom: 12%;
  
    }

   

  
  }

  .downloads {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 10px;
    border-radius: 0 0 12px 12px;
    width: 297px;
    box-sizing: border-box;
    img {
      width: 88%;
      height: auto;
    }
  }



}

@media screen and (max-width: 500px) {
  .home-page {
    .chat-section {
      // height: 450px;
      height: auto;
    }
    .introduce{
      height: 350px;
      overflow-y: auto;
    }
    .chatcont{
      height: 350px;
        overflow-y: auto;
    }
    /*wap关闭弹窗**/
    .dialog-close {
      position: absolute;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      top: -5px;
      right: -15px;
      background: url("./assets/images/dialog-close-icon.png") no-repeat center center;
      background-size: contain;
      cursor: pointer;
    }

    .dialog-craigNew {
      .craigNewP {
        height: 60px;
        padding-left: 20px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 600;
      }

      div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 10px 0 15px;

        h3 {
          color: #000000;
          font-size: 16px;

          span {
            color: #ee2547;
          }
        }

        p {
          margin-bottom: 10px;
          font-size: 15px;
        }

        button {
          width: 80%;
          height: 45px;
          border: 1px solid #ee2547;
          background: none;
          color: #ee2547;
          border-radius: 5px;
          margin-top: 15px;
          font-size: 15px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 40px;
            margin-right: 5px;
          }
        }

        button:nth-child(4) {
          background-color: #ee2547;
          color: #fff;
        }
      }
    }
  }
}
@media screen and (max-width: 500px) {
  .home-page {
    .chatcont {
      height: 500;
    }
  }
}

.native-service-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  background: #fff;

  .native-service-header {
    display: flex;
    align-items: center;
    height: 44px;
    background: #fff;
    border-bottom: 1px solid #eee;
    padding: 0 16px;
    flex-shrink: 0;
    position: relative;

    .native-service-back {
      width: 8px;
      cursor: pointer;
    }

    .native-service-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
  }

  .native-service-iframe {
    flex: 1;
    width: 100%;
    border: none;
  }
}
</style>
